import React from "react";
import {Container, Row, Col} from 'react-bootstrap';

import ApiUtils from '../util/ApiUtils';
import UIUtils from '../util/UIUtils';
import SPUtilities from "../util/SPUtilities"

import BaseAreaChart from "../reports/BaseAreaChart";
import BaseBarChart from "../reports/BaseBarChart";

import OasisNetworkNav from './OasisNetworkNav';
import Special from "../components/Special";

class NetworkStakeHistory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      isLoading: true
    }
  }

  async componentDidMount() {
    // console.log("UnityStats: in componentDidMount");

    const data = await ApiUtils.get("listData?type=networkStake");
    // console.log("data is:", data);

    this.setState({data: data, isLoading: false});
  }

  render() {
    if (this.state.isLoading) {
      return <div>Loading Network Stake History</div>;
    }

  	return (
      <div>
        <Special />
        <h5 style={{align: "center"}}><span><strong>Network Stats History</strong></span>
          <span className="buttonWithText">{UIUtils.renderReloadSize(this, 30)}</span></h5>
        <p/>
        <Container fluid>
          <Row>
            <Col md className="sectionBg">
              <BaseAreaChart title="Stake History" xAxis="Date" yAxis="Total Stake (millions)"
                showVerticalLabel={false} valueAttr="totalStakeInMillions" xAxisValueAttr="title"
                data={this.state.data} />
            </Col>
            <Col md className="sectionBg">
              <BaseAreaChart title="Validator History" xAxis="Date" yAxis="# of Consensus Validators"
                showVerticalLabel={false} valueAttr="stakingPools" xAxisValueAttr="title"
                data={this.state.data} />
            </Col>
          </Row>
          <hr/>
          <Row>
            <Col md className="sectionBg">
              <BaseAreaChart title="Network Accounts History" xAxis="Date" yAxis="# of Accounts"
                showVerticalLabel={false} valueAttr="activeAccounts" xAxisValueAttr="title"
                data={this.state.data} />
            </Col>
            <Col md className="sectionBg">
              <BaseAreaChart title="Network Delegates History" xAxis="Date" yAxis="Unique Delegates"
                showVerticalLabel={false} valueAttr="uniqueDelegates" xAxisValueAttr="title"
                data={this.state.data} />
            </Col>
          </Row>
        </Container>
        <OasisNetworkNav />
      </div>
    );
  }
}

export default NetworkStakeHistory;



// WEBPACK FOOTER //
// ./src/network/NetworkStakeHistory.js